import { ɵɵdefineInjectable, Injectable, EventEmitter, Component, Input, Output, Directive, Renderer2, ElementRef, NgModule } from '@angular/core';
import { zxcvbn } from 'zxcvbn3';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function PasswordStrengthMeterComponent_ng_container_3_small_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.feedback.warning, " ");
} }
function PasswordStrengthMeterComponent_ng_container_3_small_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const suggestion_r4 = ctx.$implicit;
    const isLast_r5 = ctx.last;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", suggestion_r4, "", isLast_r5 ? "" : " ", " ");
} }
function PasswordStrengthMeterComponent_ng_container_3_small_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 7);
    ɵngcc0.ɵɵtemplate(1, PasswordStrengthMeterComponent_ng_container_3_small_2_ng_container_1_Template, 2, 2, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.feedback.suggestions);
} }
function PasswordStrengthMeterComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PasswordStrengthMeterComponent_ng_container_3_small_1_Template, 2, 1, "small", 4);
    ɵngcc0.ɵɵtemplate(2, PasswordStrengthMeterComponent_ng_container_3_small_2_Template, 2, 1, "small", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.feedback.warning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.feedback.suggestions && ctx_r0.feedback.suggestions.length);
} }
class PasswordStrengthMeterService {
    constructor() { }
    /**
     *  this will return the password strength score in number
     *  0 - too guessable
     *  1 - very guessable
     *  2 - somewhat guessable
     *  3 - safely unguessable
     *  4 - very unguessable
     *
     *  @param password - Password
     */
    score(password) {
        const result = zxcvbn(password);
        return result.score;
    }
    /**
     * this will return the password strength score with feedback messages
     * return type { score: number; feedback: { suggestions: string[]; warning: string } }
     *
     * @param password - Password
     */
    scoreWithFeedback(password) {
        const result = zxcvbn(password);
        return { score: result.score, feedback: result.feedback };
    }
}
PasswordStrengthMeterService.ɵfac = function PasswordStrengthMeterService_Factory(t) { return new (t || PasswordStrengthMeterService)(); };
PasswordStrengthMeterService.ɵprov = ɵɵdefineInjectable({ factory: function PasswordStrengthMeterService_Factory() { return new PasswordStrengthMeterService(); }, token: PasswordStrengthMeterService, providedIn: "root" });
PasswordStrengthMeterService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordStrengthMeterService, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return []; }, null); })();

class PasswordStrengthMeterComponent {
    constructor(passwordStrengthMeterService) {
        this.passwordStrengthMeterService = passwordStrengthMeterService;
        this.minPasswordLength = 8;
        this.enableFeedback = false;
        this.colors = [];
        this.numberOfProgressBarItems = 5;
        this.strengthChange = new EventEmitter();
        this.passwordStrength = null;
        this.feedback = null;
        this.prevPasswordStrength = null;
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (changes.password) {
            this.calculatePasswordStrength();
        }
    }
    calculatePasswordStrength() {
        // TODO validation logic optimization
        if (!this.password) {
            this.passwordStrength = null;
            this.feedback = null;
        }
        else if (this.password && this.password.length < this.minPasswordLength) {
            this.passwordStrength = 0;
            this.feedback = null;
        }
        else {
            if (this.enableFeedback) {
                const result = this.passwordStrengthMeterService.scoreWithFeedback(this.password);
                this.passwordStrength = result.score;
                this.feedback = result.feedback;
            }
            else {
                this.passwordStrength = this.passwordStrengthMeterService.score(this.password);
                this.feedback = null;
            }
        }
        // Only emit the passwordStrength if it changed
        if (this.prevPasswordStrength !== this.passwordStrength) {
            this.strengthChange.emit(this.passwordStrength);
            this.prevPasswordStrength = this.passwordStrength;
        }
    }
}
PasswordStrengthMeterComponent.ɵfac = function PasswordStrengthMeterComponent_Factory(t) { return new (t || PasswordStrengthMeterComponent)(ɵngcc0.ɵɵdirectiveInject(PasswordStrengthMeterService)); };
PasswordStrengthMeterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordStrengthMeterComponent, selectors: [["password-strength-meter"]], hostAttrs: [1, "psm"], inputs: { minPasswordLength: "minPasswordLength", enableFeedback: "enableFeedback", colors: "colors", numberOfProgressBarItems: "numberOfProgressBarItems", password: "password" }, outputs: { strengthChange: "strengthChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [["role", "progressbar", 1, "psm__progress-bar", 3, "passwordStrength", "numberOfProgressBarItems", "colors"], [1, "psm__progress-bar-items"], [1, "psm__progress-bar-overlay"], [4, "ngIf"], ["class", "psm__feedback", 4, "ngIf"], ["class", "psm__suggestion", 4, "ngIf"], [1, "psm__feedback"], [1, "psm__suggestion"], [4, "ngFor", "ngForOf"]], template: function PasswordStrengthMeterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, PasswordStrengthMeterComponent_ng_container_3_Template, 3, 2, "ng-container", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("passwordStrength", ctx.passwordStrength)("numberOfProgressBarItems", ctx.numberOfProgressBarItems)("colors", ctx.colors);
        ɵngcc0.ɵɵattribute("aria-valuemin", 0)("aria-valuemax", 100);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableFeedback && ctx.feedback);
    } }, directives: function () { return [ProgressBarDirective, ɵngcc1.NgIf, ɵngcc1.NgForOf]; }, styles: ["*[_ngcontent-%COMP%], [_ngcontent-%COMP%]:after, [_ngcontent-%COMP%]:before{box-sizing:border-box}.psm__progress-bar[_ngcontent-%COMP%]{background:#fff;border-radius:3px;height:3px;margin:10px auto;position:relative}.psm__progress-bar-items[_ngcontent-%COMP%]{background:#ddd;display:flex;height:100%;justify-content:space-evenly;width:100%}.psm__progress-bar-item[_ngcontent-%COMP%]{border-right:4px solid #fff;height:100%;z-index:5}.psm__progress-bar-item[_ngcontent-%COMP%]:last-child{border-right:0}.psm__progress-bar-overlay[_ngcontent-%COMP%]{background:red;border-radius:3px;height:3px;position:absolute;top:0;transition:width .5s ease-in-out,background .25s}.psm__feedback[_ngcontent-%COMP%], .psm__suggestion[_ngcontent-%COMP%]{color:#6c757d!important;display:block;font-size:70%;font-weight:400;margin-top:.25rem}"] });
PasswordStrengthMeterComponent.ctorParameters = () => [
    { type: PasswordStrengthMeterService }
];
PasswordStrengthMeterComponent.propDecorators = {
    password: [{ type: Input }],
    minPasswordLength: [{ type: Input }],
    enableFeedback: [{ type: Input }],
    colors: [{ type: Input }],
    numberOfProgressBarItems: [{ type: Input }],
    strengthChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordStrengthMeterComponent, [{
        type: Component,
        args: [{
                selector: "password-strength-meter",
                template: "<div\n  class=\"psm__progress-bar\"\n  role=\"progressbar\"\n  [passwordStrength]=\"passwordStrength\"\n  [numberOfProgressBarItems]=\"numberOfProgressBarItems\"\n  [colors]=\"colors\"\n  [attr.aria-valuemin]=\"0\"\n  [attr.aria-valuemax]=\"100\"\n>\n  <div class=\"psm__progress-bar-items\"></div>\n  <div class=\"psm__progress-bar-overlay\"></div>\n</div>\n<ng-container *ngIf=\"enableFeedback && feedback\">\n  <small class=\"psm__feedback\" *ngIf=\"feedback.warning\">\n    {{ feedback.warning }}\n  </small>\n  <small\n    class=\"psm__suggestion\"\n    *ngIf=\"feedback.suggestions && feedback.suggestions.length\"\n  >\n    <ng-container\n      *ngFor=\"let suggestion of feedback.suggestions; last as isLast\"\n    >\n      {{ suggestion }}{{ isLast ? \"\" : \" \" }}\n    </ng-container>\n  </small>\n</ng-container>\n",
                host: {
                    class: "psm"
                },
                styles: ["*,:after,:before{box-sizing:border-box}.psm__progress-bar{background:#fff;border-radius:3px;height:3px;margin:10px auto;position:relative}.psm__progress-bar-items{background:#ddd;display:flex;height:100%;justify-content:space-evenly;width:100%}.psm__progress-bar-item{border-right:4px solid #fff;height:100%;z-index:5}.psm__progress-bar-item:last-child{border-right:0}.psm__progress-bar-overlay{background:red;border-radius:3px;height:3px;position:absolute;top:0;transition:width .5s ease-in-out,background .25s}.psm__feedback,.psm__suggestion{color:#6c757d!important;display:block;font-size:70%;font-weight:400;margin-top:.25rem}"]
            }]
    }], function () { return [{ type: PasswordStrengthMeterService }]; }, { minPasswordLength: [{
            type: Input
        }], enableFeedback: [{
            type: Input
        }], colors: [{
            type: Input
        }], numberOfProgressBarItems: [{
            type: Input
        }], strengthChange: [{
            type: Output
        }], password: [{
            type: Input
        }] }); })();

class ProgressBarDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.colors = [];
        this.defaultColors = [
            "darkred",
            "orangered",
            "orange",
            "yellowgreen",
            "green",
        ];
        this.progressBar = this.el.nativeElement;
    }
    ngOnChanges(changes) {
        if (changes.numberOfProgressBarItems) {
            this.setProgressBarItems();
        }
        this.setProgressBar();
    }
    setProgressBarItems() {
        const progressBarItemContainer = this.progressBar.querySelector(".psm__progress-bar-items");
        const width = 100 / this.numberOfProgressBarItems;
        progressBarItemContainer.childNodes.forEach((item) => {
            this.renderer.removeChild(progressBarItemContainer, item);
        });
        Array(this.numberOfProgressBarItems)
            .fill(1)
            .forEach((_) => {
            const progressBarItem = this.renderer.createElement("div");
            this.renderer.addClass(progressBarItem, "psm__progress-bar-item");
            this.renderer.setStyle(progressBarItem, "width", `${width}%`);
            this.renderer.appendChild(progressBarItemContainer, progressBarItem);
        });
    }
    setProgressBar() {
        const progressBarOverlayWidth = this.getFillMeterWidth(this.passwordStrength);
        const progressBarOverlayWidthInPx = `${progressBarOverlayWidth}%`;
        const progressLevelBasedOnItems = (progressBarOverlayWidth / 100) * this.numberOfProgressBarItems;
        const progressBarOverlayColor = this.getMeterFillColor(progressLevelBasedOnItems);
        this.renderer.setAttribute(this.progressBar, "aria-valuenow", progressBarOverlayWidthInPx);
        this.renderer.setAttribute(this.progressBar, "data-strength", `${this.passwordStrength || "0"}`);
        const overlayElement = this.progressBar.querySelector(".psm__progress-bar-overlay");
        if (overlayElement) {
            this.renderer.setStyle(overlayElement, "width", progressBarOverlayWidthInPx);
            this.renderer.setStyle(overlayElement, "background-color", progressBarOverlayColor);
        }
    }
    getFillMeterWidth(strength) {
        if (strength === null || strength === undefined) {
            return 0;
        }
        const strengthInPercentage = strength !== null ? ((strength + 1) / 5) * 100 : 0;
        const roundedStrengthInPercentage = this.getRoundedStrength(strengthInPercentage, 100 / this.numberOfProgressBarItems);
        return roundedStrengthInPercentage;
    }
    getMeterFillColor(progressLevel) {
        if (!progressLevel ||
            progressLevel <= 0 ||
            (progressLevel > this.colors.length &&
                progressLevel > this.defaultColors.length)) {
            return this.colors[0] ? this.colors[0] : this.defaultColors[0];
        }
        const index = progressLevel - 1;
        return this.colors[index] ? this.colors[index] : this.defaultColors[index];
    }
    getRoundedStrength(strength, roundTo) {
        return Math.round(strength / roundTo) * roundTo;
    }
}
ProgressBarDirective.ɵfac = function ProgressBarDirective_Factory(t) { return new (t || ProgressBarDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ProgressBarDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ProgressBarDirective, selectors: [["", 8, "psm__progress-bar"]], inputs: { colors: "colors", numberOfProgressBarItems: "numberOfProgressBarItems", passwordStrength: "passwordStrength" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
ProgressBarDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
ProgressBarDirective.propDecorators = {
    numberOfProgressBarItems: [{ type: Input }],
    passwordStrength: [{ type: Input }],
    colors: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBarDirective, [{
        type: Directive,
        args: [{
                selector: ".psm__progress-bar"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { colors: [{
            type: Input
        }], numberOfProgressBarItems: [{
            type: Input
        }], passwordStrength: [{
            type: Input
        }] }); })();

class PasswordStrengthMeterModule {
}
PasswordStrengthMeterModule.ɵfac = function PasswordStrengthMeterModule_Factory(t) { return new (t || PasswordStrengthMeterModule)(); };
PasswordStrengthMeterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PasswordStrengthMeterModule });
PasswordStrengthMeterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordStrengthMeterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [PasswordStrengthMeterComponent, ProgressBarDirective],
                exports: [PasswordStrengthMeterComponent, ProgressBarDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PasswordStrengthMeterModule, { declarations: function () { return [PasswordStrengthMeterComponent, ProgressBarDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PasswordStrengthMeterComponent, ProgressBarDirective]; } }); })();

/*
 * Public API Surface of password-strength-meter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PasswordStrengthMeterComponent, PasswordStrengthMeterModule, PasswordStrengthMeterService, ProgressBarDirective };

